'use client';
import {ReactNode, useState} from "react";
import {createHttpConcern} from "@web-libs/core/http/infrastructure/client-side/use-http.concern";
import {HttpContext} from "@web-libs/core/http/infrastructure/client-side/http.context";

export const HttpProvider = ({children, tenantId, lang}: { children: ReactNode, tenantId:string , lang: string}) => {
    const [httpConcern] = useState(createHttpConcern(tenantId, lang))
    return (
        <HttpContext.Provider value={httpConcern}>
            {children}
        </HttpContext.Provider>
    )
}
